import {
    ExportarRelatorioControleManutencaoDiaService,
    ExportarRelatorioControleManutencaoSemSistemaService,
    ExportarRelatorioPDFControleManutencaoDiaService,
    ExportRelatorioControleManutencaoService,
    IRelatorioControleManutecaoRequest,
} from "../../../../Services/AssistenciaTecnica/Atendimento/RelatorioControle/RelatorioControleManutencaoServices";
import { Controller } from "../../../Controller";

export async function ExportRelatorioControleManutencaoController(
    data: IRelatorioControleManutecaoRequest
) {
    return Controller(ExportRelatorioControleManutencaoService(data));
}

export async function ExportarRelatorioControleManutencaoDiaController(
    comSistema: boolean,
    DT_INICIO: string,
    DT_FIM: string
) {
    return Controller(
        ExportarRelatorioControleManutencaoDiaService(
            comSistema,
            DT_INICIO,
            DT_FIM
        )
    );
}

export async function ExportarRelatorioPDFControleManutencaoDiaController(
    comSistema: boolean,
    DT_INICIO: string,
    DT_FIM: string,
    ID_USUARIO: number
) {
    return Controller(
        ExportarRelatorioPDFControleManutencaoDiaService(
            comSistema,
            DT_INICIO,
            DT_FIM,
            ID_USUARIO
        )
    );
}

export async function ExportarRelatorioControleManutencaoSemSistemaController(
    data: IRelatorioControleManutecaoRequest,
    comSistema: boolean
) {
    return Controller(
        ExportarRelatorioControleManutencaoSemSistemaService(data, comSistema)
    );
}
